<template>
  <div v-if="value">
    <!-- 교환 정보 -->
    <div>
      <table class="delivery-order-info" style="margin-top:12px;margin-right:12px">
        <tbody>
        <tr>
          <td class="order-info-title">총 주문 상품 금액</td>
          <td>
            <div>교환 전 {{ beforeProductPrice | currency }}</div>
            <div>교환 후 {{ currentProductPrice | currency }}</div>
          </td>
        </tr>
        <tr>
          <td class="order-info-title">적립금 사용</td>
          <td>최종 사용 금액: -{{ value.point | currency }}</td>
        </tr>
        <tr>
          <td class="order-info-title">쿠폰 할인</td>
          <td>최종 사용 금액: -{{ value.point | currency }}</td>
        </tr>
        <tr>
          <td class="order-info-title">초기 배송비</td>
          <td>{{ this.order.delivery_cost | currency }}</td>
        </tr>
        <tr>
          <td class="order-info-title">교환 배송비</td>
          <td>{{ value.delivery_cost | currency }}</td>
        </tr>
        <tr>
          <td class="order-info-title">교환 전 총 결제 금액</td>
          <td>{{ beforeTotalPrice | currency }}</td>
        </tr>
        <tr>
          <td class="order-info-title">교환 후 총 결제 금액</td>
          <td>{{ currentTotalPrice | currency }}</td>
        </tr>
        <tr>
          <td class="order-info-title" style="background-color: #EBEAE4">차액</td>
          <td style="background-color: #EBEAE4">{{ value.margin | currency }}</td>
        </tr>
        </tbody>
      </table>

      <table class="delivery-order-info" style="margin-top:12px" v-if="value.margin>0">
        <tbody>
        <tr>
          <td class="order-info-title">차액 결제 방법</td>
          <td>현금(입금) 추가 결제</td>
        </tr>
        <tr>
          <td class="order-info-title">입금자 명</td>
          <td v-if="value.deposit_name">{{ value.deposit_name }}</td>
        </tr>
        </tbody>
      </table>
      <table class="delivery-order-info" style="margin-top:12px" v-if="value.refund_info.bank">
        <tr>
          <td class="order-info-title">환불 계좌</td>
          <td v-if="value.refund_info">{{ value.refund_info.bank }} {{ value.refund_info.account_num }} ({{ value.refund_info.name }})</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
  export default {
    name: "exchange-info",
    props: {
      exchange_id: {
        type: Number,
        required: false
      },
      order: {
        type: Object,
        required: false
      }
    },
    data () {
      return {
        value: undefined
      }
    },
    created () {
      this.getData();
    },
    computed: {
      beforeTotalPrice () {
        return this.getTotal(this.value.order_product, 'total_price');
      },
      beforeProductPrice () {
        return this.getTotal(this.value.order_product, 'product_price');
      },
      currentTotalPrice () {
        return this.getTotal(this.value.exchange_product, 'total_price');
      },
      currentProductPrice () {
        return this.getTotal(this.value.exchange_product, 'product_price');
      }
    },
    methods: {
      getTotal (list, key) {
        let total = 0;
        list.forEach(item => {
          total += item[key];
        });
        return total;
      },
      getData () {
        this.$axios.get(this.getUrl(`delivery/order/${this.$route.query.id}/exchange/${this.exchange_id}`)).then(res => {
          this.value = res.data;
        })
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  .delivery-order-info
    width 100%

  .order-info-title
    background-color #eee

  .delivery-order-info td
    text-align center !important
    border 1px solid #e0d9d9
    padding 6px
    vertical-align middle !important

</style>
